/** The macro split the Calorie / BMR & Macro Calculator uses for each goal (a fixed starting point, not a prescription). Shared with the API (core/synced). */
export const MACRO_GOALS = [
  { id: "lose", label: "Lose Weight", proteinPct: 0.35, carbPct: 0.35, fatPct: 0.30 },
  { id: "maintain", label: "Maintain Weight", proteinPct: 0.30, carbPct: 0.40, fatPct: 0.30 },
  { id: "gain", label: "Gain Muscle", proteinPct: 0.30, carbPct: 0.45, fatPct: 0.25 },
] as const;
export type MacroGoalId = (typeof MACRO_GOALS)[number]["id"];
/** Institute of Medicine Acceptable Macronutrient Distribution Ranges for adults, share of calories (DRI report 2005). */
export const AMDR = { protein: [0.10, 0.35], carbs: [0.45, 0.65], fat: [0.20, 0.35] } as const;
/** Grams for a calorie target: protein and carbohydrate 4 kcal per gram, fat 9. */
export function macroGrams(calories: number, goal: { proteinPct: number; carbPct: number; fatPct: number }) {
  return { protein: (calories * goal.proteinPct) / 4, carbs: (calories * goal.carbPct) / 4, fat: (calories * goal.fatPct) / 9 };
}
